import { render, staticRenderFns } from "./menu-drilldown-menu-list-item.vue?vue&type=template&id=8a9ac4f4&"
import script from "./menu-drilldown-menu-list-item.vue?vue&type=script&lang=ts&"
export * from "./menu-drilldown-menu-list-item.vue?vue&type=script&lang=ts&"
import style0 from "./menu-drilldown-menu-list-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports